export default [
    {
      path: '/label/my-vidcents',
      name: 'My VidCents Label',
      title: "My VidCents",
      component: () => import(/* webpackChunkName: 'my-vidcents-label' */ './views/Index.vue')
    },
  ]
  